import * as React from "react";

interface ZoomProps {
  imgUrl: string;
  zoomScale: number;
  height: number;
  width: number;
  transitionTime?: number;
}

const ZoomOnHover: React.FC<ZoomProps> = ({ imgUrl, zoomScale, height, width, transitionTime = 0.5 }) => {
  const [zoom, setZoom] = React.useState(false);
  const [mouseX, setMouseX] = React.useState<number | null>(null);
  const [mouseY, setMouseY] = React.useState<number | null>(null);
  const imageRef = React.useRef<HTMLDivElement>(null);

  const outerDivStyle: React.CSSProperties = {
    height: `${height}px`,
    width: `${width}px`,
    backgroundSize: "contain",
  };

  const innerDivStyle: React.CSSProperties = {
    height: `${height}px`,
    width: `${width}px`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    transition: `transform ${transitionTime}s ease-out`,
    backgroundImage: `url('${imgUrl}')`,
  };

  const handleMouseOver = () => {
    setZoom(true);
  };

  const handleMouseOut = () => {
    setZoom(false);
  };

  const handleMouseMovement = (e: React.MouseEvent<HTMLDivElement>) => {
    const { left: offsetLeft, top: offsetTop } = imageRef.current!.getBoundingClientRect();
    const { width, height } = imageRef.current!.style;
    const x = ((e.pageX - offsetLeft) / parseInt(width!, 10)) * 100;
    const y = ((e.pageY - offsetTop) / parseInt(height!, 10)) * 100;

    setMouseX(x);
    setMouseY(y);
  };

  const transform = {
    transformOrigin: `${mouseX}% ${mouseY}%`,
  };

  return (
    <div style={{ ...outerDivStyle }} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onMouseMove={handleMouseMovement} ref={imageRef}>
      <div
        style={{
          ...transform,
          ...innerDivStyle,
          transform: zoom ? `scale(${zoomScale})` : "scale(1.0)",
        }}
      />
    </div>
  );
};

export default ZoomOnHover;
